export const SECURITY_LEVEL = {
  NONE: "NONE",
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
};

export const QUESTION_TYPE = {
  MCQ: "MCQ",
  DESCRIPTIVE_TYPING: "DESCRIPTIVE_TYPING",
  DESCRIPTIVE_UPLOAD: "DESCRIPTIVE_UPLOAD",
};
